import React from 'react';
import { useSearchBox } from 'react-instantsearch';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface SearchBoxProps {
  placeholder?: string;
  className?: string;
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  placeholder = 'Search...',
  className = '',
}) => {
  const { query, refine } = useSearchBox();

  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        placeholder={placeholder}
        className="pl-10"
        value={query}
        onChange={(e) => refine(e.target.value)}
      />
    </div>
  );
};